import i from './master-user-base.container';

export default i;
